
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/tv3/marato/en/totes-maratons",
      function () {
        return require("private-next-pages/corporatiu/tv3/marato/en/totes-maratons/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/tv3/marato/en/totes-maratons"])
      });
    }
  